<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>monitor</mat-icon>
        <div>Frequência</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">
      </div>

    </mat-toolbar>
  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !_totenService.spinner}" color='primary' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <div style="width: 800px; margin: auto;">

  <mat-card>

    <div style="display: flex; flex-direction: row; border: solid 1px silver;">

      <div style="width: 600px; margin: 10px;">
        <mat-select (ngModelChange)='selectedByProduct($event)' [ngModel]='selectedProduct.id'
          placeholder="Selecione um evento">
          <mat-option *ngFor="let product of products" [value]="product.id">
            {{ product.name }}
          </mat-option>
        </mat-select>
      </div>

      <div *ngIf="countUniqueEntries" style='width:60px; font-weight: bold; text-align: center;  margin: 10px;'>
        {{countUniqueEntries}}
      </div>

      <a *ngIf="dataSource && dataSource.data.length > 0" mat-button (click)="exportToCsv()" style='width:60px;  text-align: center;'>
        <mat-icon color='primary'>download</mat-icon>
      </a>

    </div>

  </mat-card>

  <mat-card>

    <!-- TABLE -->
    <mat-table [dataSource]="dataSource">

      <!-- date Column -->
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.date.seconds*1000 | date: 'dd/MM/yyyy - hh:mm a' }}
        </mat-cell>
      </ng-container>

      <!-- member Column -->
      <ng-container matColumnDef="member">
        <mat-header-cell *matHeaderCellDef> Inscrito </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.member_name }}
        </mat-cell>
      </ng-container>

      <!-- delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div *ngIf='_authService.isAdmin'>
            <a mat-button (click)='delete(element)' style='background-color: whitesmoke;'>
              <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
              </mat-icon>
            </a>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->


  </mat-card>


</div>

</div>